import { skipToken } from '@tanstack/react-query';
import { compareByMultiple, desc } from '../../../../shared/utils/sortUtils.ts';
import { trpc } from '../../../utils/trpc/trpc.ts';


export function useMeasurementOptions(
    equipment: string,
    product: string | null,
    protocolId: string | null,
    inOfflineMode: boolean,
) {
    const isEnabled = product || inOfflineMode && protocolId;

    const { data: measurementOptions } = trpc.measureInterval.getMeasurementOptions.useQuery(
        isEnabled ? {
            equipment,
            ...(inOfflineMode ? { protocolId } : { product }),
        } : skipToken
    );

    const optionsSorted = measurementOptions?.slice().sort(compareByMultiple([
        desc(it => it.latestRecord?.measurementStart),
        desc(it => it.protocol.createTime),
    ]));

    return optionsSorted;
}
